//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import config from '@/config';

import versionNumber from '@/components/versionNumber';
const ENVIRONMENT = [
  { label: '开发', value: 'Dev' },
  { label: '测试', value: 'Test' },
  { label: '预发布', value: 'Pre' },
  { label: '正式', value: 'Prod' },
];
const envs = {
  development: 'Dev',
  test: 'Test',
  preview: 'Pre',
  production: 'Prod',
};
export default {
  components: {
    versionNumber,
  },
  data() {
    return {
      loading: false,
      search: {
        env: '',
        tenant_id: '',
        page: 1,
        page_size: 10,
      },
      creatFrom: {
        tag: '',
        description: '',
      },
      total: 0,
      list: [],
      creatVisible: false,
      creatRules: {
        tag: {
          required: true,
          message: '请输入完整版本号',
          trigger: 'blur',
        },
      },
    };
  },
  computed: {
    ENVIRONMENT() {
      return ENVIRONMENT;
    },
    ...mapGetters('user', ['getTenantInfo']),
  },
  created() {
    this.search.tenant_id = `T${this.getTenantInfo.id}`;
    this.search.env = envs[config.env || 'production'] || 'Prod';
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        this.$request({
          url: this.$api.metaGetTagList,
          data: {
            env: this.search.env,
            tenant_id: this.search.tenant_id, // 租户id，不为空则查找对应租户id的版本
            limit: this.search.page_size,
            offset: this.search.page_size * (this.search.page - 1),
          },
          cb: ({ list, count }) => {
            this.list = list;
            this.total = Number(count);
            this.loading = false;
          },
        });
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    onSubmit() {
      this.search.page_size = 10;
      this.search.page = 1;
      this.getList();
    },
    async setTag() {
      this.$refs.creatFrom.validate(async (valid) => {
        if (valid) {
          try {
            this.$request({
              url: this.$api.metaSetTag,
              data: { ...this.creatFrom },
              cb: () => {
                this.creatFrom = {
                  tag: '',
                  description: '',
                };
                this.$message({
                  message: '设置成功',
                  type: 'success',
                });
                this.creatVisible = false;
                this.search.page = 1;
                this.getList();
              },
            });
          } catch (err) {
            console.log(err);
            this.creatVisible = true;
          }
        } else {
          return false;
        }
      });
    },
    itemDetail({ tag, tenant_id }) {
      this.$router.push({
        name: 'versions-detail',
        query: {
          env: this.search.env,
          tag,
          tenant_id,
        },
      });
    },
    itemDiff({ tag, tenant_id }) {
      this.$router.push({
        name: 'versions-diff',
        query: {
          env: this.search.env,
          tag,
          tenant_id,
        },
      });
    },
    handleSizeChange(value) {
      this.search.page_size = value;
      this.search.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.getList();
    },
  },
};
